<template>
  <div class="App r-cover overflow-hidden">
    <transition name="fade">
      <router-view />
    </transition>

    <vue-progress-bar />

    <Cookies v-if="!loading" />

    <!-- Loading screen transition -->
    <transition name="fade">
      <Loading v-if="loading" />
    </transition>

    <IePrompt />
  </div>
</template>

<script>
import Cookies from '@/components/utility/Cookies.vue'
import Loading from '@/components/utility/Loading.vue'
import IePrompt from '@/components/utility/IePrompt.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'App',

  components: {
    Cookies,
    Loading,
    IePrompt
  },

  data: () => ({
    laptopBreakpoint: 1366,
    tabletBreakpoint: 1024,
    mobileBreakpoint: 767
  }),

  computed: {
    // Data
    ...mapState([
      'defaultDocumentTitle',
      'browser',
      'windowDimensions',
      'lteLaptop',
      'lteTablet',
      'lteMobile',
      'loading',
      'pageMeta'
    ]),
  },

  watch: {
    /*$mq: {
      immediate: true,
      handler() {
        const lteMobile = this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg'
        this.$store.commit('lteMobile', lteMobile)
      }
    },*/
    pageMeta: {
     handler() { this.pushDocumentTitle() },
     deep: true
    }
  },

  created() {
    // Browser
    this.$store.commit('browser', this.$browser.meta.name)
    // Window resize
    window.addEventListener('resize', this.resizeHandler)
    // Progress bar
    this.$Progress.start()
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
  },

  beforeMount() {
    // Touch
    window.addEventListener('touchstart', this.touchstart)
    // Window resize
    this.resizeHandler()
    // FIRST
    const { $store, windowDimensions, laptopBreakpoint, tabletBreakpoint, mobileBreakpoint } = this
    $store.commit('lteLaptop', windowDimensions.width <= laptopBreakpoint)
    $store.commit('lteTablet', windowDimensions.width <= tabletBreakpoint)
    $store.commit('lteMobile', windowDimensions.width <= mobileBreakpoint)
    // Start Page title
    this.pushDocumentTitle()
  },

  methods: {
    touchstart() {
      window.removeEventListener('touchstart', this.touchstart)
      document.body.setAttribute('id', 'touch')
      this.$store.commit('isTouch')
    },
    resizeHandler() {
      const { $store, lteLaptop, lteTablet, lteMobile, laptopBreakpoint, tabletBreakpoint, mobileBreakpoint } = this
      const body = window.document.body
      const compatMode = window.document.compatMode === 'CSS1Compat'
      const docElemPropWidth = window.document.documentElement.clientWidth
      const windowWidth = window.innerWidth || (compatMode && docElemPropWidth) || (body && body.clientWidth) || docElemPropWidth
      const docElemPropHeight = window.document.documentElement.clientHeight
      const windowHeight = window.innerHeight || (compatMode && docElemPropHeight) || (body && body.clientHeight) || docElemPropHeight
      // Update Store -> Window Dimensions
      const windowDimensions = {
        width: windowWidth,
        height: windowHeight
      }
      $store.commit('windowDimensions', windowDimensions)
      // Update Store -> <= Laptop
      if (windowWidth > laptopBreakpoint && lteLaptop) {
        $store.commit('lteLaptop', false)
      } else if (windowWidth <= laptopBreakpoint && !lteLaptop) {
        $store.commit('lteLaptop', true)
      }
      // Update Store -> <= Tablet
      if (windowWidth > tabletBreakpoint && lteTablet) {
        $store.commit('lteTablet', false)
      } else if (windowWidth <= tabletBreakpoint && !lteTablet) {
        $store.commit('lteTablet', true)
      }
      // Update Store -> <= Mobile
      if (windowWidth > mobileBreakpoint && lteMobile !== false) {
        $store.commit('lteMobile', false)
      } else if (windowWidth <= mobileBreakpoint && lteMobile !== true) {
        $store.commit('lteMobile', true)
      }
    },
    truncateString(text) {
      const maxLength = 28
      const cappedText = text.slice(0, (maxLength - 1))
      return text.length > maxLength ? `${cappedText}&hellip;` : text
    },
    pushDocumentTitle() {
      const textArr = []
      const { pageTitle, parentTitle } = this.pageMeta
      if (pageTitle) { textArr.push(this.truncateString(pageTitle)) }
      if (parentTitle) { textArr.push(this.truncateString(parentTitle)) }
      textArr.push(this.defaultDocumentTitle)
      document.title = this.htmlDecode( textArr.join(' | ') )
    }
  }
}
</script>

